<template>
  <img v-if="typeof this.$theme.image('header') === 'string'" :src="$theme.image(image)" />
  <component v-else :is="this.$theme.image(image)"></component>
</template>

<script>
export default {
  name: 'ThemeImage',
  props: {
    image: {
      type: String,
      default: () => '',
    },
  },
};
</script>
